export const emailAndNumberStyles = 'text-md-semibold'

export const getContainerStyles = (isLargeDevice: boolean) => `
    flex flex-col 
    w-[437px]
    border rounded-[24px] mt-32px 
    ${isLargeDevice ? 'p-[32px]' : 'p-[16px]'}
`

export const otpDescriptionTextStyles = `text-md-regular`

export const getButtonContainerStyles = (isLargeDevice: boolean) =>
   `w-full ${isLargeDevice ? 'mt-6' : 'mt-4'} `

export const otpDescriptionWrapperStyles = `flex flex-col`

export const otpTextStyles = `text-xl-semibold`

export const verifyOtpButtonStyles = `w-full self-center`

export const leftArrowButtonStyles = `mb-4 cursor-pointer self-start rounded-[10px] !p-0`

export const getErrorMessageStyles = (isLargeDevice: boolean) =>
   `${
      isLargeDevice ? 'text-sm-regular' : 'text-md-regular'
   } mt-2 max-w-full text-center`
